"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.debug = void 0;
const debug_1 = require("debug");
exports.debug = debug_1.default('snyk-cpp-plugin');
//# sourceMappingURL=debug.js.map